import { render, staticRenderFns } from "./WhatsAppMessageTemplateFooter.vue?vue&type=template&id=f428a224&scoped=true&"
import script from "./WhatsAppMessageTemplateFooter.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessageTemplateFooter.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessageTemplateFooter.vue?vue&type=style&index=0&id=f428a224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f428a224",
  null
  
)

export default component.exports